export default "__VITE_ASSET__CH5078lp__"